import { palette } from "@ottatech/design";

export const EmptyHeart = (): React.ReactElement => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.91667 4.0808L6.72101 2.689C6.15261 2.02735 5.26354 1.6 4.35417 1.6C2.7614 1.6 1.58333 2.81164 1.58333 4.31608C1.58333 5.25784 2.01493 6.11312 2.76032 6.95016C3.44434 7.71832 4.2694 8.34 5.03988 8.92048C5.12881 8.98752 5.217 9.05392 5.30417 9.12C6.05205 9.6868 6.90674 10.2633 7.58535 10.7041C7.70213 10.7799 7.81304 10.8514 7.91667 10.9177C8.0203 10.8514 8.13121 10.7799 8.24798 10.7041C8.9266 10.2633 9.78128 9.6868 10.5292 9.12C10.6163 9.05392 10.7045 8.98752 10.7934 8.92048C11.564 8.34 12.389 7.71832 13.073 6.95016C13.8184 6.11312 14.25 5.25784 14.25 4.31608C14.25 2.81164 13.0719 1.6 11.4792 1.6C10.5698 1.6 9.68074 2.02735 9.11232 2.689L7.91667 4.0808ZM6.94474 0.78748C6.18939 0.289888 5.28442 0 4.35417 0C1.91583 0 0 1.89907 0 4.31608C0 7.2 2.48474 8.99368 4.09284 10.203C4.1829 10.2707 4.2702 10.3364 4.35417 10.4C5.9375 11.6 7.91667 12.8 7.91667 12.8C7.91667 12.8 9.89583 11.6 11.4792 10.4C11.5632 10.3364 11.6504 10.2707 11.7405 10.203C13.3486 8.99368 15.8333 7.12512 15.8333 4.31608C15.8333 1.89907 13.9175 0 11.4792 0C10.549 0 9.64393 0.289888 8.8886 0.78748C8.52546 1.02672 8.19684 1.31398 7.91667 1.64011C7.6365 1.31398 7.30788 1.02672 6.94474 0.78748Z"
      fill={palette.brand.black}
    />
  </svg>
);
